import React from 'react';
import { ProtectedRoute } from './ProtectedRoute';
import { GalleryAccessGate } from '../pages/SocialGalleryV2/GalleryAccess';

export default function SocialGalleryRoute({ component: Component, ...rest }) {
  return <ProtectedRoute {...rest} component={(props) => <GalleryAccessGate><Component {...props} /></GalleryAccessGate>} />;
}
